import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useEmployee } from '../context/employee';

export default function RequireAuth({ children }) {
    const { pathname } = useLocation();

    const { deviceToken, employee, isValidDeviceToken, SetOriginalPath } = useEmployee();

    useEffect(() => {
        SetOriginalPath(pathname);
    }, [pathname, SetOriginalPath]);

    if (!deviceToken && pathname !== '/sign-in') {
        return <Navigate to="/sign-in" />;
    }

    if (!isValidDeviceToken && pathname !== '/validate-token') {
        return <Navigate to="/validate-token" />;
    }

    if ((!employee || !employee.active) && pathname !== '/sign-in') {
        return <Navigate to="/sign-in" />;
    }

    return children;
}
